export default "__VITE_ASSET__5209d467__"